import React, { useContext, useState } from "react";
import { Button } from "../../../../../controls";
import {
  BlockRounded,
  LocalPrintshopRounded,
  ReplayRounded,
} from "@mui/icons-material";
import { lsGet, PrintDiv, ToFormData } from "../../../../../hooks/Method";
// import PrintSaleReceipt from "../PrintSaleReceipt";
import { Alert, Dialog } from "../../../../../layout";
import EditSale from "../../EditSale/EditSale";
import { action, API, controller } from "../../../../../api/api";
import { useNavigate } from "react-router-dom";
import PrintReceipt from "../../../../Sales/POS/Checkout/PrintReceipt/PrintReceipt";
import { AppContext } from "App";

const Header = ({ value, setSells, handleClose }) => {
  const { access } = useContext(AppContext);
  const [showEditForm, setShowEditForm] = useState(false);
  const navigate = useNavigate();
  const activeReg = lsGet("activeReg");
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handlePrint = () => {
    setTimeout(() => {
      PrintDiv("printSaleReceipt");
    }, 500);
  };

  const handleVoid = () => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "You're about to void this sale",
      subTitle:
        "This will return the products to your inventory and remove any recorded payments. You’ll still be able to see the details of this sale once it's been voided. This can’t be undone.",
      onConfirm: () => {
        API(controller.Sell + action.Void).post(
          ToFormData({
            id: value.id,
            outletId: activeReg && activeReg.outletId ? activeReg.outletId : 0,
            date: new Date().toISOString(),
          }),
          (res) => {
            if (res && res.status === 200) {
              setSells &&
                setSells((j) => [
                  ...j.map((s) => (s.id === value.id ? { ...res.result } : s)),
                ]);

              handleClose && handleClose();

              // Hide confirmation form.
              setAlert({
                isOpen: false,
                type: "",
                title: "",
                subTitle: "",
              });
            } else
              setAlert({
                isOpen: true,
                type: "warning",
                title: "Warning",
                subTitle: res.msg,
              });
          }
        );
      },
    });
  };

  const handleReturn = () => {
    handleClose && handleClose();
    navigate(`/sell_return_form/${value.id}`);
  };

  return (
    <>
      <div className="d-none" id="printSaleReceipt">
        {/* {value && value.id && <PrintReceipt data={value} />} */}
        {value && value.id && <PrintReceipt data={value} />}
      </div>
      {/* ------ Type 3 : Void ------ */}
      {value.type !== 3 && (
        <div className="flex gap-[10px] flex-wrap mr-[10px]">
          {access?.salesHistory?.returnSale &&
            value.status === 2 &&
            value.netPayable > 0 && (
              <Button
                onClick={handleReturn}
                variant="text"
                startIcon={<ReplayRounded />}
              >
                Return Items
              </Button>
            )}
          {access?.salesHistory?.printReceipt && (
            <Button
              onClick={handlePrint}
              variant="text"
              startIcon={<LocalPrintshopRounded />}
            >
              Print Receipt
            </Button>
          )}
          {access?.salesHistory?.void && value.netPayable > 0 && (
            <Button
              className="!text-red-600 !bg-red-100"
              onClick={handleVoid}
              variant="text"
              startIcon={<BlockRounded />}
            >
              Void
            </Button>
          )}
        </div>
      )}

      {showEditForm && (
        <Dialog show={showEditForm} onClose={false} maxWidth="md">
          <EditSale {...{ value, setShowForm: setShowEditForm }} />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Header;
